import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import styles from "./OAuth2AuthorizeError.module.scss";

const ERROR_FTL_IDS: Record<string, string> = {
  invalid_request: "oauth2-error-invalid-request",
  invalid_client: "oauth2-error-invalid-client",
  unauthorized_client: "oauth2-error-unauthorized-client",
  access_denied: "oauth2-error-access-denied",
  unsupported_response_type: "oauth2-error-unsupported-response-type",
  invalid_scope: "oauth2-error-invalid-scope",
  server_error: "oauth2-error-server-error",
  temporarily_unavailable: "oauth2-error-temporarily-unavailable",
};

const OAuth2AuthorizeError = ({
  error,
  errorDescription,
}: {
  error: string;
  errorDescription: string;
}) => {
  const { l10n } = useLocalization();

  const displayDescription =
    errorDescription ||
    l10n.getString(
      ERROR_FTL_IDS[error] || "oauth2-error-unknown"
    );

  return (
    <div className={styles.errorContainer}>
      <div className={styles.errorIcon}>
        <span className="narmi-icon-alert-circle-fill" />
      </div>
      <h2 className={styles.errorTitle}>
        {l10n.getString("oauth2-authorize-error-title")}
      </h2>
      <p className={styles.errorDescription}>{displayDescription}</p>
      <div className={styles.errorActions}>
        <Button
          onClick={() => window.history.back()}
          label={l10n.getString("button-back")}
        />
      </div>
    </div>
  );
};

export default OAuth2AuthorizeError;

